// =============================================================================
// TYPES
// =============================================================================

export interface MedianElement {
  type: 'Median';
  params: {
    /** Parent triangle ID */
    of: string;
    /** Vertex name: 'A', 'B', or 'C' */
    from: string;
  };
}
